import { COLORS } from "./colors";

// Selectable task colors shown in the task color picker.
// The rogue "#F6C343" yellow was replaced by the warning token.
export const TASK_COLORS = [
  COLORS.warning,
  "#4CAF50",
  "#2196F3",
  "#FF5722",
  "#9C27B0",
  "#607D8B",
];

const WARNING_TASK_STYLE = {
  bg: "#D4A72C",
  text: "#FFFFFF",
  shadow: "rgba(212, 167, 44, 0.4)",
};

// Solid task-bar palette keyed by the stored task color hex.
// Background: solid saturated colors, Text: white for high contrast.
// No borders (modern pattern) - uses shadow for elevation instead.
export const TASK_COLOR_PALETTE = {
  // Warning (token) - for general/default tasks
  [COLORS.warning]: WARNING_TASK_STYLE,
  // Legacy pre-token yellow; tasks stored with it render as warning
  "#F6C343": WARNING_TASK_STYLE,
  // Green - for success/completed tasks
  "#4CAF50": {
    bg: "#2E7D32",
    text: "#FFFFFF",
    shadow: "rgba(46, 125, 50, 0.4)",
  },
  // Blue - for info/in-progress tasks
  "#2196F3": {
    bg: "#1565C0",
    text: "#FFFFFF",
    shadow: "rgba(21, 101, 192, 0.4)",
  },
  // Orange/Red - for urgent/high priority
  "#FF5722": {
    bg: "#D84315",
    text: "#FFFFFF",
    shadow: "rgba(216, 67, 21, 0.4)",
  },
  // Purple - for special/milestone tasks
  "#9C27B0": {
    bg: "#7B1FA2",
    text: "#FFFFFF",
    shadow: "rgba(123, 31, 162, 0.4)",
  },
  // Gray - for neutral/pending tasks
  "#607D8B": {
    bg: "#455A64",
    text: "#FFFFFF",
    shadow: "rgba(69, 90, 100, 0.4)",
  },
  // Cyan (Brand) - for primary actions
  [COLORS.secondary]: { bg: COLORS.primary, text: "#FFFFFF", shadow: "rgba(8, 39, 70, 0.4)" },
};

// Fallback for unknown colors - generates a modern solid color from hex
export const generateTaskColors = (hex) => {
  // Convert hex to RGB
  const num = parseInt(hex.replace("#", ""), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  // Darken the color by ~25% for solid background
  const darken = (c) => Math.max(0, Math.floor(c * 0.75));
  const bgR = darken(r);
  const bgG = darken(g);
  const bgB = darken(b);

  const bg = `#${((bgR << 16) | (bgG << 8) | bgB).toString(16).padStart(6, "0")}`;
  const shadow = `rgba(${bgR}, ${bgG}, ${bgB}, 0.4)`;

  return { bg, text: "#FFFFFF", shadow };
};

export const getTaskColors = (hex) =>
  TASK_COLOR_PALETTE[hex] || generateTaskColors(hex);
